import { net_filemanage } from "@/api/http";
export const API_STFMFM02C02_Initialize = (...params) =>
net_filemanage.post("/api/STFMFM02C02/Initialize", ...params)
export const API_STFMFM02C02_OpneFIlePreview = (...params) =>
net_filemanage.post("/api/STFMFM02C02/OpneFIlePreview", ...params)
export const API_STFMFM02C02_EditFolderPreview = (...params) =>
net_filemanage.post("/api/STFMFM02C02/EditFolderPreview", ...params)
export const API_STFMFM02C02_CheckFile= (...params) =>
net_filemanage.post("/api/STFMFM02C02/CheckFile", ...params)
export const API_STFMFM02C02_SearchFileList= (...params) =>
net_filemanage.post("/api/STFMFM02C02/SearchFileList", ...params)
export const API_STFMFM02C02_Download= (...params) =>
net_filemanage.post("/api/STFMFM02C02/Download", ...params)
export const API_STFMFM02C02_Export= (...params) =>
net_filemanage.post("/api/STFMFM02C02/Export", ...params)
export const API_STFMFM02C02_SetFilter= (...params) =>
net_filemanage.post("/api/STFMFM02C02/SetFilter", ...params)